import React from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import '../../RfController.css';

const RfControllerOverlay = ({ rasterErrorMessage, handleOverlayClose }) => {
  return (
    <div className="RfController_OverlayContainer">
      <div className="RfController_OverlayCloseSection">
        <div className="RfController_OverlayCloseSection_ButtonContainer">
          <SvgAF
            onClick={handleOverlayClose}
            img={IconLoader.icon_close_errorbox}
            hover={IconLoader.icon_close_errorbox_hover}
          />
        </div>
      </div>

      <div className="RfController_Content">
        <div className="RfController_OverlayMessage">
          <span>{rasterErrorMessage}</span>
        </div>
        <div className="RfController_OverlayButtonWindow">
          <div className="RfController_OverlayTop"></div>
          <div className="RfController_OverlayPanel"></div>
          <div className="RfController_OverlayBottom"></div>
        </div>
      </div>

      <div className="RfController_OverlayBack"></div>
    </div>
  );
};

export default RfControllerOverlay;
